import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { eur } from "../../utils/format";

const formatDate = (dateString) =>
  new Date(dateString).toLocaleDateString("el-GR", { weekday: "long", day: "2-digit", month: "2-digit" });

const List = () => {
  const navigate = useNavigate();
  const reports = useSelector((state) => state.ekkathariseis.list);

  return (
    <div className="space-y-3">
      {reports.map((item) =>
        Object.keys(item).map((i) => {
          const obj = item[i];
          if (typeof obj !== "object") return null;
          return (
            <button
              key={obj.date + i}
              onClick={() => navigate(`/ekkathariseis/${obj.date}/${i}`)}
              className="block w-full overflow-hidden rounded-2xl border border-brand-600/10 bg-white text-left
                         shadow-card transition active:scale-[0.99]"
            >
              <div className="bg-brand-600 px-4 py-2.5">
                <h3 className="font-semibold capitalize text-white">{formatDate(obj.date)}</h3>
              </div>
              <div className="flex items-center justify-between px-4 py-3">
                <strong className="truncate text-slate-700">{obj?.supplierName}</strong>
                <span className="shrink-0 font-bold text-brand-700">{eur(obj.totalEkkatharisi)}</span>
              </div>
            </button>
          );
        }),
      )}
    </div>
  );
};

export default List;
